// will be mocked for tests
export const baseUrl = import.meta.env.BASE_URL;
